import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import Section from '@/components/layout/section.tsx';

export default function Footer() {
	const { t } = useTranslation();

	return (
		<footer className="border-t border-gray-200">
			<Section className="flex items-center py-6 max-sm:py-4 justify-between gap-4 text-gray-500">
				<span>© Copyright {new Date().getFullYear()}</span>

				<Link to="/privacy-policy">{t('global.privacy_policy')}</Link>
			</Section>
		</footer>
	);
}
